import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_comment_user_profile_content = _resolveComponent("comment-user-profile-content")
  const _component_base_balloon = _resolveComponent("base-balloon")
  const _component_click_outside = _resolveComponent("click-outside")
  const _component_floating_content = _resolveComponent("floating-content")

  return (_openBlock(), _createBlock(_component_floating_content, {
    "is-processing": _ctx.isProcessing,
    "is-content-visible": _ctx.isContentVisible,
    onPositionUpdate: $options.onPositionUpdate,
    onClose: $options.onClose,
    onMouseleave: $options.onMouseLeave
  }, _createSlots({
    trigger: _withCtx(() => [
      _renderSlot(_ctx.$slots, "trigger", _normalizeProps(_guardReactiveProps({ showBalloon: $options.showBalloon, closeBalloon: $options.closeBalloon })))
    ]),
    _: 2 /* DYNAMIC */
  }, [
    ($options.hasUrlName)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createVNode(_component_click_outside, { call: $options.onClickOutside }, {
              default: _withCtx(() => [
                _createVNode(_component_base_balloon, _mergeProps(_ctx.balloonProps, {
                  class: ['gfu-floating-balloon',
                                       {'gfu-floating-balloon--processing': _ctx.isProcessing}]
                }), {
                  default: _withCtx(() => [
                    _createVNode(_component_comment_user_profile_content, _mergeProps($options.commentUserProfileContentProps, { onClose: $options.onClose }), null, 16 /* FULL_PROPS */, ["onClose"])
                  ]),
                  _: 1 /* STABLE */
                }, 16 /* FULL_PROPS */, ["class"])
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["call"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-processing", "is-content-visible", "onPositionUpdate", "onClose", "onMouseleave"]))
}